import "common/extensions/yup";

import * as React from "react";
import { render } from "react-dom";
import "@jsq/ds/index.css";

import { initObservability } from "common/utils/o11y";
import { initThirdPartyScripts } from "common/config/initThirdPartyScripts";
import { setupCoordinatedLogout } from "common/utils/coordinatedLogout";
import { Portal } from "./Portal";
import "./styles.scss";

initThirdPartyScripts();
initObservability({ appName: "portal" });
setupCoordinatedLogout();

render(<Portal />, document.getElementById("root"));

if (process.env.NODE_ENV === "development") {
  if (module.hot) {
    module.hot.accept();
  }
}
